import { CoralogixBrowserSdkConfig } from "@coralogix/browser/src/types";
import { SectionWiseFlagObject } from "../types/FlagsTypes";

/*
 Read the current environment from the global window variable
 Set the appropriate global config for the environment variable
 Return this env config
 Default to UAT if no env is present
*/

type EnvironmentConfigKeysType = {
  featureFlags: SectionWiseFlagObject,
  proxyEnvironment: string,
  appEnvironment: string,
  basicAuthToken: {
    currenciesdirect: string,
    torfx: string,
    torfxoz: string,
    fcg: string,
    currenciesdirectsa: string
  },
  octaBasicAuthToken: {
    currenciesdirect: string,
    torfx: string,
    torfxoz: string,
    fcg: string,
    currenciesdirectsa: string
  },
  apiEndPoint: {
    resetPassword: string,
    newPassword: string,
    verificationLink: string,
    login: string,
    customerDocuments: string,
    urlGeneratorSend: string,
    getBankDetails: string,
    checkDuplicate: string,
    createPartner: string,
    approvePartner: string,
    oauth: string,
    bankDocUpload: string
  },
  apiKey: {
    api: string,
    sandbox: string,
    invoice: string,
    launchDarkly: string
  },
  coralogixConfig: {
    public_key: string,
    application: string,
    coralogixDomain: string
  },
  srlDomainUrl: {
    cd: string,
    cdsa: string,
    torfx: string,
    torfxoz: string,
    fcg: string
  },
  CI: false
};

type EnvironmentConfigObjectType = {
  SIT: EnvironmentConfigKeysType;
  UAT: EnvironmentConfigKeysType;
  PROD: EnvironmentConfigKeysType;
};

const ENVIRONMENT_CONFIG: EnvironmentConfigObjectType = {
  SIT: {
    featureFlags: {
      LANGUAGE_DROPDOWN: true,
    },
    proxyEnvironment: 'SIT',
    appEnvironment: 'sit',
    basicAuthToken: {
      currenciesdirect: 'bDc2N2Q0ZTJhOWFiOTc0NGQ5YTIyZmM0NzY0NzQwYzE5NDpiNzQwOWI5NDg1ZmM0NDEwOWZmNmNkM2NkY2UxMjYyOQ==',
      torfx: 'bDc5ZDUyNGIxYzgwOTI0NzE0ODkzMTk2MTdkYThlMDYyNTowZjVmOWE0ODY5YTU0ZTJiODZmMjlhNDk4YjI3YTNlZQ==',
      torfxoz: 'bDcyMzdlODdkYmE5Yzg0ZTIyYjAwNWMwNzZiNzJmOGU0YTphOWRlN2M5ZDhjN2U0OGNiOWY2OWE2OGViZGNlYjZhYg==',
      fcg: 'bDdjNDgwZDVlMGZmNDA0YTRiOTQ1ODkzMDA2MDMwY2E2NzpkNTY3MTZjYzBiYjQ0ZjM1YWU3NjFmODU0NTk0NGE3Zg==',
      currenciesdirectsa: 'bDcyMDEyMDNiYTVjOTk0NmE4OWViZmVjMmUyMWQ4MDU4YzoxN2ZiMjM3MTEwNGU0M2NmOTFjNzk4NDU1NmM1ZjI5MQ=='
    },
    octaBasicAuthToken: {
      currenciesdirect: 'bDc5MzkyYWI3OWE0NDA0ZDk0YTYxNzY5OWJjNGIxOThmMTo0NTRiNjE1NDIzYjI0M2IzOGRiM2YwMWU1ZTAwNzQ3NQ==',
      torfx: 'bDcyOTE2NGVjNmZlNmY0OGU4OTMxNzhiN2QzYmE1MDZhYTo4NmEwYTk2N2Q2NTY0NWQzYjE4OGRkMzFhM2QyYjRlNQ==',
      torfxoz: '',
      fcg: '',
      currenciesdirectsa: 'bDdiNmQzNjNmNDYyNTA0ZTkyOGJlNmI3ZmIzZTA0YjgyOTo2Mzc5ZWU1ZTNkMDU0NWU2YmQzNzQyZThlY2M4MjgzYQ=='
    },
    apiEndPoint: {
      resetPassword: '/v1/resetPasswordEmail',
      newPassword: '/v1/affiliate-portal/setpassword',
      verificationLink: '/v1/affiliate-portal/verification-link',
      login: '/v1/affiliate-portal/affiliate/login',
      customerDocuments: '/v1/customers',
      urlGeneratorSend: '/v1/affiliate-portal/registration/send',
      getBankDetails: '/v1/affiliate-portal/references/get-bankdetails',
      checkDuplicate: '/v1/affiliate-portal/customer/check-duplicate',
      createPartner: '/v1/affiliate-portal/affiliate/create',
      approvePartner: '/v1/affiliate-portal/affiliate/approval',
      oauth: '/auth/oauth/v2/token',
      bankDocUpload: '/v1.0/uploadDocsCompliance_SIT'
    },
    apiKey: {
      api: '5b6d707a-1288-4d96-83fd-30822838fc27',
      sandbox: 'l767d4e2a9ab9744d9a22fc4764740c194',
      invoice: 'l7cc61769e135e4849901238ad454f7588',
      launchDarkly: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY_SIT || ''
    },
    coralogixConfig: {
      public_key: '',
      application: 'Affiliate-Portal',
      coralogixDomain: 'EU2'
    },
    srlDomainUrl: {
      'cd': 'pfxreg.sit.currenciesdirect.com/register-page',
      'cdsa': 'www.currenciesdirect.co.za/register',
      'torfx': 'pfxreg.sit.torfx.com/register-page',
      'torfxoz': 'pfxreg.sit.torfx.com.au/register-page',
      'fcg': 'www.foremostcurrencygroup.co.uk/register'
    },
    CI: false
  },
  UAT: {
    featureFlags: {
      LANGUAGE_DROPDOWN: true
    },
    proxyEnvironment: 'UAT',
    appEnvironment: 'uat',
    basicAuthToken: {
      currenciesdirect: 'bDc5Y2RlNmRhMTFiOWM0ZTljYjU1YWRjZGY1MTNiZjhhNDoxZDk3NTRmZGMzMWI0MDE0ODQwNGY5ZjM1MGY0YTcwZg==',
      torfx: 'bDdkMjM1N2RmZjQ3YTY0NWI0ODMxNmRjYzhiMWEzNWRkNDowYmM0MmE0MzY1OTQ0MDhhOTg2Yzk4ZWYwMGM5OGJmZg==',
      torfxoz: 'bDdjYTFkN2RkNmMxN2E0ZmExOTU4MzJkZGI2YzUwNDBiODphNWUyNjhmMzYxMTU0M2UzYjI0MTcwYjk0Y2U4ZmVlYg==',
      fcg: 'bDcxYjMwMjJiNTM2NWY0Y2Q4YTFlNTRlM2I1MWIxYmQxOTpjZWM0M2NjMzMzOTI0ZjY5ODgzNDdkODM5MTRhM2IyNw==',
      currenciesdirectsa: 'bDc0YTU0YjU1YjgzM2Y0ZDRlYTk2YzZhMTdhZjA2NWFkODphZGNlMzBkY2YyOGM0YzNkOTNmNDdhYzI1M2IzMjQxZA=='
    },
    octaBasicAuthToken: {
      currenciesdirect: 'bDc1YTI0OTEzZjJmYzU0NTc2YTY0NGViM2NiZmY4MDU2OTozNzU0ZDE5MTRhYjU0ZjAyYTVjNDQwYTM1YjY2ZGQxMg==',
      torfx: 'bDcyYmUyYjgyMGE4ZDU0MjNiYjQwNTliNmMxMTc0MzM0Zjo2ZTlmNDZhZjkyYzg0NTdkYTQxZTFkZTg0YWFkNDdjOQ==',
      torfxoz: '',
      fcg: '',
      currenciesdirectsa: 'bDc2ZGJiMzliMTMxMjE0NjMxYTZkOWI0MmViYmIyNTlhYTphOThlYWRhN2Y2M2E0ZTQ0OTIxZTY0OTdlNjI1MjU3OA=='
    },
    apiEndPoint: {
      resetPassword: '/v1/resetPasswordEmail',
      newPassword: '/v1/affiliate-portal/setpassword',
      verificationLink: '/v1/affiliate-portal/verification-link',
      login: '/v1/affiliate-portal/affiliate/login',
      customerDocuments: '/v1/customers',
      urlGeneratorSend: '/v1/affiliate-portal/registration/send',
      getBankDetails: '/v1/affiliate-portal/references/get-bankdetails',
      checkDuplicate: '/v1/affiliate-portal/customer/check-duplicate',
      createPartner: '/v1/affiliate-portal/affiliate/create',
      approvePartner: '/v1/affiliate-portal/affiliate/approval',
      oauth: '/auth/oauth/v2/token',
      bankDocUpload: '/v1.0/uploadDocsCompliance'
    },
    apiKey: {
      api: '5b6d707a-1288-4d96-83fd-30822838fc27',
      sandbox: 'l7xxcbba6402039f43039f3e15a35d7a96f0',
      invoice: 'l7xxe6de912cea064c84bbd28a57d1857e72',
      launchDarkly: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY_UAT || ''
    },
    coralogixConfig: {
      public_key: process.env.REACT_APP_CORALOGIX_KEY_UAT || '',
      application: 'Affiliate-Portal',
      coralogixDomain: 'EU2'
    },
    srlDomainUrl: {
      'cd': 'pfxreg.uat.currenciesdirect.com/register-page',
      'cdsa': 'www.currenciesdirect.co.za/register',
      'torfx': 'pfxreg.uat.torfx.com/register-page',
      'torfxoz': 'pfxreg.uat.torfx.com.au/register-page',
      'fcg': 'www.foremostcurrencygroup.co.uk/register'
    },
    CI: false
  },
  PROD: {
    featureFlags: {
      LANGUAGE_DROPDOWN: true
    },
    proxyEnvironment: 'PROD',
    appEnvironment: 'production',
    basicAuthToken: {
      currenciesdirect: 'bDdmMmQ2NzkxMjRkZDc0ZmM5YTAxZDk0MDI4MzJjYjVhYjo1YmYzNjEyZmQ1YmM0Zjk5OTM3N2EwNjg5NWE1ZjM3OA==',
      torfx: 'bDc1MTVkOGRkMmYyMjY0ZGVhOWRiMDE5YThkOGNiOTVlMzpjNTM5YjllMTk4ODE0NDY3YjJmZjIxNmI0ZmUyMGNmNg==',
      torfxoz: 'bDc3ZDk5OTIwYzYxNzE0YjM5ODk5Y2JjOTc5YTQ5NDgzODplNjZkZDBjOWJhNDU0ZDQ2ODRkNjM2YTc0ZTAwZTRlMA==',
      fcg: 'bDc1NGU2NWQ2NzdhMTQ0YTNhOTkwNjA0YTU3MzY1OWY1MTo3NmQ1MTgwNDFiYjE0ZTU4OGFhYWY1MWVjMTY2YTJmNQ==',
      currenciesdirectsa: 'bDc5ZGFkZmUwZTQyMzg0MmNiYTk4NmIwMDIzZDg3NGJjNToxZjI4YjE4OWNiN2Y0YWUwYjY5MDhiMGQ5NmNjZWM1NA=='
    },
    octaBasicAuthToken: {
      currenciesdirect: 'bDdhNTBkMDE0MWY5MjA0MTA1OWM0ZTRjNTgxNTVkMjZlODpiNjJkNGYwM2I1Yzc0ZjI1YjIyMDUwOTQ4NDk3Y2EwNg==',
      torfx: 'bDdjYThjYjU5ZTk0MDE0MWI2OGQxYjgxNTZkNGZjYWU1NzpjODMwYTQ3NWQ0NDI0YjBmYjEzODQzMGMzNDUwYmUxMg==',
      torfxoz: '',
      fcg: '',
      currenciesdirectsa: 'bDc2NWZkMjM0MjlhZjM0MjZjYWMyODg4ZTAxMWU1MDMyYjpiZWQxMmE4MmJiYWI0NmQyODVlZGQ2ZmQ5NmIzMjQ2Mg=='
    },
    apiEndPoint: {
      resetPassword: '/v1/resetPasswordEmail',
      newPassword: '/v1/affiliate-portal/setpassword',
      verificationLink: '/v1/affiliate-portal/verification-link',
      login: '/v1/affiliate-portal/affiliate/login',
      customerDocuments: '/v1/customers',
      urlGeneratorSend: '/v1/affiliate-portal/registration/send',
      getBankDetails: '/v1/affiliate-portal/references/get-bankdetails',
      checkDuplicate: '/v1/affiliate-portal/customer/check-duplicate',
      createPartner: '/v1/affiliate-portal/affiliate/create',
      approvePartner: '/v1/affiliate-portal/affiliate/approval',
      oauth: '/auth/oauth/v2/token',
      bankDocUpload: '/v1.0/uploadDocsCompliance'
    },
    apiKey: {
      api: 'l7f2d679124dd74fc9a01d9402832cb5ab',
      sandbox: 'l7f2d679124dd74fc9a01d9402832cb5ab',
      invoice: 'l7xxcf7c9936a1f24cca9fcb7808e225a263',
      launchDarkly: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY_PROD || ''
    },
    coralogixConfig: {
      public_key: process.env.REACT_APP_CORALOGIX_KEY_PROD || '',
      application: 'Affiliate-Portal',
      coralogixDomain: 'EU2'
    },
    srlDomainUrl: {
      'cd': 'pfxreg.currenciesdirect.com/register-page',
      'cdsa': 'www.currenciesdirect.co.za/register',
      'torfx': 'pfxreg.torfx.com/register-page',
      'torfxoz': 'pfxreg.torfx.com.au/register-page',
      'fcg': 'www.foremostcurrencygroup.co.uk/register'
    },
    CI: false
  }
};

// @ts-ignore
const CURRENT_ENV: string = window['SERVER_DATA'] && window['SERVER_DATA'] !== '__SERVER_DATA__' ? window['SERVER_DATA'] : 'UAT';

console.log('EnvironmentConfig - CURRENT_ENV: ', CURRENT_ENV);

class EnvironmentConfig {
  currentEnvironmentConfig: EnvironmentConfigKeysType = ENVIRONMENT_CONFIG[CURRENT_ENV];

  constructor() {
    if (this.currentEnvironmentConfig) {
      console.log('New instance cannot be created');
      console.log('constructor currentEnvironmentConfig: ', this.currentEnvironmentConfig);
    }
  }

  getSpecificEnvConfigProperty(property: string) {
    return this.currentEnvironmentConfig[property];
  }

  getCurrentEnvConfig() {
    return this.currentEnvironmentConfig;
  }
}

const CurrentEnvironmentConfig = Object.freeze(new EnvironmentConfig());

export const getConfigProperty = (
  propertyName: string
): any | CoralogixBrowserSdkConfig =>
  CurrentEnvironmentConfig.getSpecificEnvConfigProperty(propertyName);